import rolesImage from '../../resources/Flora-Fauna.png';
import syncImage from '../../resources/syncbuttons.png';
import scanImage from '../../resources/Scanning.png';
import miniatureImage from '../../resources/Miniature.png';
import noHelmetsImage from '../../resources/NoHelmets.png';

import './index.css'

export default function Features()
{
    return(
        <div className="features">
            {/* Big text heading */}
            <div className="features-heading flex items-center justify-center px-4 mt-20">
                <h1 className="text-white text-3xl md:text-5xl font-bold text-center leading-relaxed max-w-4xl"
                    data-aos="fade-up" >
                    Throughout history, mankind has significantly altered the natural world... Sometimes with catastrophic consequences. <br/>
                    Climate change, soil degradation, and water pollution are among the major challenges we have to face.
                </h1>
            </div>
            <div className='feature-item left' data-aos="fade-right">
                <img src={rolesImage} alt="example"/>
                <p className="text-xl md:text-2xl">Discuss with your partner in-game. Choose between 2 roles and explore the VEs together. One of you will be the Flora Expert and the other one is going to be the Fauna Expert.</p>
            </div>
            <div className="feature-item right" data-aos="fade-left" >
                <p className="text-xl md:text-2xl">Use synchronized actions with your partner to learn more about the environment you are in.</p>
                <img src={syncImage} alt="example" />
            </div>
            <div className='feature-item left' data-aos="fade-right">
                <img src={scanImage} alt="example"/>
                <p className="text-xl md:text-2xl">Use your in-game Scanner to gain data about specific items on the environment. See the information on your helmet's HUD.</p>
            </div>
            <div className="feature-item right" data-aos="fade-left" >
                <p className="text-xl md:text-2xl">Choose the best Solutions to convert the Dystopian future. Build the new Eutopian future together with your partner. </p>
                <img src={miniatureImage} alt="example" />
            </div>
            <div className='feature-item left' data-aos="fade-right">
                <img src={noHelmetsImage} alt="example"/>
                <p className="text-xl md:text-2xl">See the effects of Nature-Based Solutions on our future. Cooperate with your partner to learn how we can avoid a Dystopian future, and embrace Eutopia.</p>
            </div>
        </div>

    )
}